var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-dynamic-filter",style:({width: _vm.width})},[_c(_vm.type,{ref:"filter",tag:"component",attrs:{"searchIcon":_vm.searchIcon,"dynamicFilter":_vm.value},on:{"confirm":_vm.handleConfirm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }